import { render, staticRenderFns } from "./set_placard.vue?vue&type=template&id=5bb845f2&scoped=true"
import script from "./set_placard.vue?vue&type=script&lang=js"
export * from "./set_placard.vue?vue&type=script&lang=js"
import style0 from "./set_placard.vue?vue&type=style&index=0&id=5bb845f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb845f2",
  null
  
)

export default component.exports